/**
 * IntakePage — /intake. Embeds Merlin's discovery interviewer.
 * Merlin listens, sketches the workflow on screen, then submits a
 * structured Gherkin brief to the team. No booking, no pricing.
 */
import { Helmet } from 'react-helmet-async';
import MerlinIframe from '../components/primitives/merlin/MerlinIframe.jsx';

export default function IntakePage() {
  return (
    <>
      <Helmet>
        <title>Discovery with Merlin — The Artificer's AI</title>
        <meta
          name="description"
          content="Tell Merlin what you want built. He'll listen, sketch the workflow on screen, and send a structured brief to the team."
        />
        <link rel="canonical" href="https://artificersai.com/intake" />
        <meta
          property="og:title"
          content="Discovery with Merlin — The Artificer's AI"
        />
        <meta
          property="og:description"
          content="Tell Merlin what you want built. He'll listen, sketch the workflow on screen, and send a structured brief to the team."
        />
        <meta property="og:url" content="https://artificersai.com/intake" />
      </Helmet>
      {/* pt/height offsets match the fixed Nav (~84px) so Merlin's own top bar
          isn't hidden underneath it. */}
      <section className="bg-surface text-ink-50 pt-[84px]">
        <MerlinIframe
          variant="intake"
          title="Merlin discovery agent"
          height="calc(100vh - 84px)"
        />
      </section>
    </>
  );
}
